import i18n from '@/i18n'
import vueI18n from '@/i18n/locale'
const dishesBtnStatus = {
  0: i18n._('下架'),
  1: i18n._('下架'),
  2: i18n._('上架'),
}

const dishesPutOnStatus = 1
const dishesPullOffStatus = 2
const dishesIsMustCode = 1

// 状态
const handleDishesStatus = {
  0: {
    describe: i18n._('全部'),
    handleCode: 2,
    btnTxt: i18n._('下架'),
  },
  1: {
    describe: i18n._('上架'),
    handleCode: 2,
    btnTxt: i18n._('下架'),
  },
  2: {
    describe: i18n._('下架'),
    handleCode: 1,
    btnTxt: i18n._('上架'),
  },
}

const dishesListEmptyText = i18n._('暂无菜品')
const searchEmptyText = i18n._('未搜索到相关菜品')
const pullUpLoadNoMoreTxt = i18n._('已加载全部菜品')

export const DINE_MENU_STATUS = {
  DEFAULT: -1,
  AUDIT_PENDING: 0,
  AUDIT_PASSED: 1,
  AUDIT_FAILED: 2,
}

export const FILE_SIZE_LIMIT = {
  DINE_MENU_IMG: {
    LIMIT_NUM: 20,
    LIMIT_SIZE: 20 * 1024 * 1024,
  },
  DINE_MENU_PDF: {
    LIMIT_NUM: 50,
    LIMIT_SIZE: 50 * 1024 * 1024,
  },
}
export const RELATION_TYPE = {
  OWNER: 1, // 自营
  FRANCHISEE: 2, // 加盟
}
// 代运营操作角色类型
export const OperatorTypeEnum = {
  BD: 1, // BD-Gattaran
  SHOP: 2, // 商家
  BDAPP: 3, // BD-App
}
// 代运营菜单提交类型枚举
export const MenuSourceEnum = {
  X_LINK: 5, // 其他平台链接
  DINE_MENU: 6, // 堂食图片或 pdf
}
// 代运营菜单审核状态枚举
export const AuditStatusEnum = {
  AUDITING: 0, // 审核中
  AUDIT_SUCCESS: 1, // 审核成功
  AUDIT_FAILED: 2, // 审核失败
  WAIT_AUDIT: 3, // 待送审
}

// 代运营提交页面展示的类型枚举
export const NullMenuShowStatusEnum = {
  NOT_SUBMIT: 'NOT_SUBMIT', // 未提交
  AUDITING: 'AUDITING', // 审核中
  AUDIT_FAILED: 'AUDIT_FAILED', // 审核失败
}

export const MenuRules = [
  {
    icon: 'go_icon_ok1_outlined',
    text: vueI18n.t('FoodB_dishes_JDKN_Pnvu'), // 上传清晰的菜单图片或文件：支持JPG,JPEG,PNG,PDF，大小不超过50MB
  },
  {
    icon: 'go_icon_ok1_outlined',
    text: vueI18n.t('FoodB_Menu_kRrV_DCKl'), // 图片或文件中请至少包含：菜品名称、菜品价格及菜品描述
  },
  {
    icon: 'go_icon_close1_outlined false-icon',
    text: vueI18n.t('FoodB_Menu_kbbj_QOWO'), // 请不要上传非菜单类图片，如菜品图片等
  },
]
export const MAX_STOCK = 9999

// 图片审核状态
export const IMG_AUDIT_STATUS = {
  AUDITING: 10, // 审核中
  AUDIT_SUCCESS: 21, // 审核通过
  AUDIT_FAILED: 31, // 审核失败
}
export const STOCK_AUTO_UPDATE_TIME = '03:00'

export default {
  dishesBtnStatus,
  dishesPutOnStatus,
  dishesPullOffStatus,
  dishesIsMustCode,
  handleDishesStatus,
  dishesListEmptyText,
  pullUpLoadNoMoreTxt,
  searchEmptyText,
  IMG_AUDIT_STATUS,
}
